import React from 'react';
import './Privacy.css';

const Privacy = () => {
    return (
        <div className="privacy-container">

            <h1>Política de Privacidad</h1>
            {/* <p><strong>Fecha de entrada en vigor:</strong> [Fecha]</p> */}

            <h2>1. Introducción</h2>
            <p>
                Bienvenido a la aplicación de reproducción de la radio online de <strong>Embajadores Stereo</strong>. La presente Política de Privacidad tiene como objetivo informarte de manera clara y transparente acerca de cómo recopilamos, utilizamos, protegemos y compartimos tus datos personales, en cumplimiento de la Ley 1581 de 2012 y demás normas relacionadas en Colombia, así como de otras regulaciones internacionales en materia de protección de datos.
            </p>
            <p>
                Al utilizar esta aplicación y/o sitio web, aceptas los términos y condiciones descritos en esta política.
            </p>

            <h2>2. Responsable del Tratamiento de Datos</h2>
            <p>
                {/* <strong>Embajadores del Gran Rey</strong><br /> */}
                {/* <strong>NIT:</strong> 123456789<br /> */}
                <strong>Dirección:</strong> Cl. 24 #9-91, Chinú, Córdoba<br />
                <strong>Correo electrónico:</strong> contacto@embajadoresdelgranrey.com<br />
            </p>

            <h2>3. Datos que Recopilamos</h2>
            <p>
                La información que podemos recopilar incluye, pero no se limita a:
            </p>
            <ul>
                <li><strong>Datos de Registro y Contacto:</strong> Información personal que ingresas al registrarte o crear una cuenta (por ejemplo, nombre, dirección de correo electrónico, número de teléfono).</li>
                <li><strong>Información de Uso:</strong> Datos técnicos y de navegación (dirección IP, tipo de dispositivo, sistema operativo, navegador, datos de geolocalización – cuando se haya otorgado el permiso correspondiente, entre otros) que se recogen para optimizar el funcionamiento de la aplicación y el sitio web.</li>
                <li><strong>Datos de Interacción:</strong> Información generada a partir de tu interacción con la aplicación (comentarios, encuestas, solicitudes, entre otros).</li>
                <li><strong>Cookies y Tecnologías Similares:</strong> Se utilizan para facilitar y personalizar tu experiencia, permitiendo analizar el tráfico y adaptar el contenido.</li>
            </ul>

            <h2>4. Finalidades del Tratamiento</h2>
            <p>
                Utilizaremos tus datos personales para los siguientes fines:
            </p>
            <ul>
                <li><strong>Prestación y Mejora del Servicio:</strong> Gestionar y optimizar la reproducción de la radio online, el acceso a contenidos y la experiencia del usuario.</li>
                <li><strong>Comunicación:</strong> Enviar notificaciones, boletines informativos, actualizaciones, invitaciones a eventos y otras comunicaciones relevantes, siempre y cuando nos hayas otorgado tu consentimiento.</li>
                <li><strong>Análisis y Estadísticas:</strong> Realizar análisis internos para comprender el uso de la aplicación y el sitio web, detectar y solucionar problemas técnicos, y mejorar la experiencia del usuario.</li>
                <li><strong>Seguridad:</strong> Garantizar la integridad y seguridad de nuestros sistemas, prevenir fraudes y accesos no autorizados.</li>
            </ul>

            <h2>5. Base Legal para el Tratamiento de Datos</h2>
            <p>
                El tratamiento de tus datos se realizará conforme a lo establecido en la legislación colombiana, en particular la Ley 1581 de 2012 y el Decreto 1377 de 2013, que regulan la protección de datos personales. Asimismo, en los casos en que se reciba información de usuarios de otros países, se procurará el cumplimiento de las normativas internacionales de protección de datos aplicables.
            </p>

            <h2>6. Compartición y Transferencia Internacional de Datos</h2>
            
            <h3>6.1 Compartición con Terceros</h3>
            <p>
                Tus datos personales podrán ser compartidos con terceros únicamente en los siguientes casos:
            </p>
            <ul>
                <li><strong>Proveedores de Servicios:</strong> Con empresas o entidades que prestan servicios en nuestro nombre (por ejemplo, alojamiento, análisis de datos, servicios de notificación) y que están obligadas a respetar la confidencialidad de la información.</li>
                <li><strong>Obligaciones Legales:</strong> Cuando la ley lo requiera o para atender procesos legales.</li>
                <li><strong>Consentimiento del Usuario:</strong> Cuando expresamente otorgues tu autorización para compartir tu información.</li>
            </ul>
            
            <h3>6.2 Transferencia Internacional de Datos</h3>
            <p>
                En caso de que se realice una transferencia internacional de datos, se adoptarán las medidas necesarias para garantizar que dicha información cuente con un nivel de protección adecuado conforme a lo exigido por la legislación colombiana y las normativas internacionales. Se informará previamente a los usuarios cuando se realicen transferencias de datos fuera del territorio nacional.
            </p>

            <h2>7. Seguridad de la Información</h2>
            <p>
                Implementamos medidas de seguridad técnicas y organizativas adecuadas para proteger tus datos personales contra acceso no autorizado, pérdida, divulgación o alteración. Sin embargo, es importante tener en cuenta que ningún sistema de seguridad es 100% infalible, por lo que no podemos garantizar la seguridad absoluta de la información transmitida por Internet.
            </p>

            <h2>8. Conservación de los Datos</h2>
            <p>
                Conservaremos tus datos personales durante el tiempo necesario para cumplir con las finalidades para las cuales fueron recogidos o mientras exista una relación con el usuario. Una vez cumplida la finalidad y finalizado el plazo de conservación, los datos serán eliminados o anonimizados, salvo que una norma legal exija su conservación por un período mayor.
            </p>

            <h2>9. Tus Derechos como Titular de Datos</h2>
            <p>
                De acuerdo con la Ley 1581 de 2012 y demás normas complementarias, tienes los siguientes derechos:
            </p>
            <ul>
                <li><strong>Conocer, Actualizar y Rectificar:</strong> Solicitar información sobre tus datos y actualizar o corregir aquellos que sean inexactos o incompletos.</li>
                <li><strong>Solicitar Pruebas de Autorización:</strong> Pedir evidencia del consentimiento otorgado para el tratamiento de tus datos.</li>
                <li><strong>Ser Informado:</strong> Conocer el uso que se le ha dado a tus datos.</li>
                <li><strong>Presentar Reclamos:</strong> Ante la Superintendencia de Industria y Comercio o la entidad competente en caso de que consideres que el tratamiento de tus datos vulnera la normatividad vigente.</li>
                <li><strong>Revocar el Consentimiento:</strong> En cualquier momento, salvo que ello afecte el cumplimiento de obligaciones legales.</li>
            </ul>
            <p>
                Para ejercer cualquiera de estos derechos, por favor contáctanos a través de los medios indicados en la sección de Contacto.
            </p>

            <h2>10. Uso de Cookies y Tecnologías Similares</h2>
            <p>
                Nuestra aplicación y sitio web utilizan cookies y tecnologías similares para mejorar la experiencia del usuario, analizar el tráfico y personalizar el contenido. Puedes configurar tu navegador para rechazar estas tecnologías; sin embargo, ten en cuenta que esto podría afectar algunas funcionalidades del servicio.
            </p>

            <h2>11. Cambios a la Política de Privacidad</h2>
            <p>
                Nos reservamos el derecho de modificar esta Política de Privacidad en cualquier momento para adaptarla a nuevas normativas o cambios en nuestros servicios. Cuando se realicen cambios significativos, se te notificará a través de la aplicación, el sitio web o por otros medios. Te recomendamos revisar periódicamente esta política para estar informado sobre cualquier actualización.
            </p>

            <h2>12. Contacto</h2>
            <p>
                Si tienes preguntas, inquietudes o solicitudes relacionadas con esta Política de Privacidad o con el tratamiento de tus datos personales, por favor contáctanos a través de:
            </p>
            <ul>
                <li><strong>Correo electrónico:</strong> contacto@embajadoresdelgranrey.com</li>
                <li><strong>Dirección:</strong> Cl. 24 #9-91, Chinú, Córdoba</li>
            </ul>
        </div>
    );
};

export default Privacy;
